import { PageWrapper, Spinner, Tabs } from '@welbe/web-design-system';
import DashboardIcon from 'App/assets/img/dashboard-outline-black.svg?url';
import { ErrorInfo } from 'App/Components/ErrorInfo/ErrorInfo';
import { BrokersContext } from 'contexts/Brokers/Brokers';
import Analytics from 'helpers/analytics';
import { useContext, useEffect, useState } from 'react';
import { getUrlQuicksightDashboard } from 'services/services';
import {
	Container,
	ContainerSpinner,
	Iframe,
	IframeWrapper,
	Wrapper,
} from './Dashboard.style';

export const Dashboard = (): JSX.Element => {
	const { isBroker } = useContext(BrokersContext);
	const [activeUrl, setActiveUrl] = useState();
	const [isLoading, setIsLoading] = useState(false);
	const [hasError, setHasError] = useState(false);
	const [tab, setTab] = useState(0);

	const getActiveUrl = async () => {
		setIsLoading(true);
		try {
			const { data } = await getUrlQuicksightDashboard(isBroker && tab === 1);
			setActiveUrl(data?.content?.url);
		} catch (error) {
			setHasError(true);
			console.error('Error getting the dashboard url', error);
		} finally {
			setIsLoading(false);
		}
	};

	const tabs = [
		{
			name: 'Vista General',
			content: (
				<>
					{isLoading ? (
						<ContainerSpinner>
							<Spinner size="50px" />
						</ContainerSpinner>
					) : (
						<Iframe src={activeUrl} allow="geolocation" />
					)}
				</>
			),
		},
	];

	if (isBroker) {
		tabs.push({
			name: 'Vista Broker',
			content: (
				<>
					{isLoading ? (
						<ContainerSpinner>
							<Spinner size="50px" />
						</ContainerSpinner>
					) : (
						<Iframe src={activeUrl} allow="geolocation" />
					)}
				</>
			),
		});
	}

	useEffect(() => {
		getActiveUrl();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [tab]);

	const handleTab = (tab: number) => {
		if (tab === 0) Analytics.track('home', `Open Dashboard`);
		if (tab === 1) Analytics.track('home', `Open Broker Dashboard`);
		setTab(tab);
	};

	return (
		<Container data-testid="dashboard">
			<PageWrapper
				icon={<img src={DashboardIcon} alt="Dashboard icon" />}
				title="Dashboard"
			>
				<IframeWrapper>
					{hasError ? (
						<Wrapper>
							<ErrorInfo />
						</Wrapper>
					) : (
						<Tabs
							tabItems={tabs}
							height="fit-content"
							onChange={handleTab}
							side="right"
						/>
					)}
				</IframeWrapper>
			</PageWrapper>
		</Container>
	);
};
